require("@/assets/sass/main.scss");

import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import {store} from "./store";
import VueGtag from "vue-gtag";

createApp(App).use(router).use(VueGtag, {config: { id: "GTM-6G6G" }}).use(store).mount("#app");



